import { DbLoadProductList } from "../../../data/usecases/load-product-list";
import { DbLoadProductListByManyCodes } from "../../../data/usecases/load-product-list-by-many-codes";
import { LoadProductList } from "../../../domain/usecases/load-product-list";
import { LoadProductListByManyCodes } from "../../../domain/usecases/load-product-list-by-many-codes";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeAxiosHttpClient } from "../http";
import { makeMUApiUrl } from "../http/mu-api-url-factory";

export const makeDbLoadProductListByManyCodes =
  (): LoadProductListByManyCodes =>
    new DbLoadProductListByManyCodes(
      makeMUApiUrl("/product/many"),
      makeAxiosHttpClient()
    );
